import { loadFont } from '@modules/fonts';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import type { Maybe } from 'graphql/jsutils/Maybe';
import type React from 'react';
import { useEffect, useState } from 'react';

interface CardFontLoaderProps extends React.PropsWithChildren {
  primaryFontUrl: Maybe<string>;
  secondaryFontUrl: Maybe<string>;
  className?: string;
}

export function CardFontLoader({
  primaryFontUrl,
  secondaryFontUrl,
  className,
  children,
}: CardFontLoaderProps) {
  const [primaryCssId, setPrimaryCssId] = useState('');
  const [secondaryCssId, setSecondaryCssId] = useState('');

  useEffect(() => {
    const loadPrimaryFont = async (url: string) => {
      const family = await loadFont(url, '600 700');
      setPrimaryCssId(family);
    };

    if (primaryFontUrl) {
      loadPrimaryFont(primaryFontUrl);
    } else {
      setPrimaryCssId('');
    }
  }, [primaryFontUrl]);

  useEffect(() => {
    const loadSecondaryFont = async (url: string) => {
      const family = await loadFont(url, '400 500');
      setSecondaryCssId(family);
    };

    if (secondaryFontUrl) {
      loadSecondaryFont(secondaryFontUrl);
    } else {
      setSecondaryCssId('');
    }
  }, [secondaryFontUrl]);

  return (
    <div
      className={className}
      style={assignInlineVars({
        '--card-primary-font': primaryCssId || undefined,
        '--card-secondary-font': secondaryCssId || undefined,
      })}
    >
      {children}
    </div>
  );
}
